import request from '@/utils/request'

export function getProduceOrderList(data) {
  return request.post('/produce-order/list', data)
}

export function addProduceOrder(data) {
  return request.post('/produce-order/add', data)
}

export function modifyProduceOrder(data) {
  return request.post('/produce-order/modify', data)
}

export function deleteProduceOrder(data) {
  return request.post('/produce-order/delete', data)
}

export function modifyStatusProduceOrder(data) {
  return request.post('/produce-order/modify-status', data)
}

export function qualityStatusOfProduceOrder(data) {
  return request.post('/produce-order/quality-status', data)
}

export function unQualityProduceOrder(data) {
  return request.post('/produce-order/un-quality', data)
}

export function listByGoods(data) {
  return request.post('/produce-order/list-by-goods', data)
}



// WEBPACK FOOTER //
// ./src/api/produce/order.js